export interface BoxShadowConfig {
  boxShadow?: string;
  horizontalLength?: string;
  verticalLength?: string;
  boxShadowBlur?: string;
  boxShadowSpread?: string;
  shadowColor?: string;
  inset?: boolean;
}
